
import { useParams } from "react-router-dom";
import { Icon, Label } from 'semantic-ui-react'
import { useQuery, gql, useMutation } from '@apollo/client';

import { useIsAdmin } from '../../../hooks/isAdmin';
import { GET_TAGS as GET_POSSIBLE_TAGS } from '../../../queries/tags';
import { TagsPicker } from '../../../components/Protected/TagsPicker';

const UPDATE_COURSE_TAGS = gql`
mutation UpdateCourseTags($courseId: Int!, $tagIds: [Int!]!) {
    updateCourseTags(courseId: $courseId, tagIds: $tagIds) {
        status
    }
}
`;

const CourseTags = ({ tags, refetchCourse }: { tags: any, refetchCourse: any }) => {
    let { id: courseId } = useParams();
    const isAdmin = useIsAdmin();

    const [updateCourseTags] = useMutation(UPDATE_COURSE_TAGS);

    const { loading, error, data} = useQuery(GET_POSSIBLE_TAGS, {
        variables: {
            showPeopleTags: false,
            showCourseTags: true,
        }
    });

    if (!isAdmin) {
        return (tags || []).map((tag: any) => (
          <Label size='small'>
            <Icon name='tag' /> {tag.name}
          </Label>
        ));
    }

    return (
        <TagsPicker
            tags={tags}
            refetchParent={refetchCourse}
            loading={loading}
            error={error}
            data={data}
            updateTags={updateCourseTags}
            payload={{ courseId: Number(courseId) }}
        />
    )
}

export { CourseTags }
